(function () {
	"use strict";

	angular
		.module("portalApp")
		.controller("CardiacUploadCtrl", CardiacUploadController);

	/**
	 * @ngInject
	 */

	function CardiacUploadController($log, appConfig, appSession, $sce, $state) {
		$log = $log.getInstance("CardiacUploadCtrl", "color:blue");
		var vm = this;
		vm.$sce = $sce;
		vm.$onInit = onInit;
		vm.$log = $log;
		vm.$state = $state;
		vm.createdCardiacUploaderUrl = createdCardiacUploaderUrl;
		vm.appSession = appSession; 
		vm.appConfig = appConfig;
		vm.cardiacUploaderUrl = null;
		vm.errorMessage = "No study found, while loading Cardiac Upload";
		

		function onInit() {
			$log.debug("Cardiac Upload Controller Loaded");
            vm.createdCardiacUploaderUrl();
        }

		function createdCardiacUploaderUrl() {
			const currentStudy = vm.appSession.getStudy();
			vm.cardiacUploaderUrl = vm.appConfig.external.cardiacUploadUrl;
			
			if(vm.$state.params.cduMode === vm.appConfig.cduMode.Respiratory){
				vm.cardiacUploaderUrl = vm.cardiacUploaderUrl + "respiratory/";
			}
			
			if(!currentStudy) { 
				vm.$log.error(vm.errorMessage);
				return;
			}
			
			const studyId = vm.appSession.getStudy().id;
			const token = vm.appSession.getSessionToken();
			const urlToRedirect = `${vm.cardiacUploaderUrl}home?studyAccount=${currentStudy.number}&studyId=${studyId}&msp3Token=${token}`;
			vm.cardiacUploaderUrl = vm.$sce.trustAsResourceUrl(urlToRedirect);
		}
	}	

})();
